// extracted by mini-css-extract-plugin
export default {"root":"VeloxWordmark_root__ev9bK","letters":"VeloxWordmark_letters__50fGd","gap":"VeloxWordmark_gap__uUFYb","ring":"VeloxWordmark_ring__c3mWe","sub":"VeloxWordmark_sub__Z4JAX"};